export default __webpack_public_path__ + "static/media/empty-actual-hours.8e6b0bcc.svg";